import React, {useState, useEffect} from "react";
import { ReactComponent as AgressiveIcon } from 'assets/icons/agressive_smile.svg';
import { ReactComponent as AdvertisingIcon } from 'assets/icons/advertising.svg';
import { ReactComponent as SwearingIcon } from 'assets/icons/swearing.svg';
import { ReactComponent as InfoIcon } from 'assets/icons/question.svg';
import { StandartButton } from "commons/form-controls";
import { connect } from "react-redux";
import { modalShowToggle } from "store/modal";
import s from "./keywords-list.module.scss"

let mapStateToProps = (state) => ({
    isAuth: state.authorization.isAuth,
    deviceType: state.header.deviceType,
    showRightMenu: state.SideBarMenu.showRightMenu,
})

const KeywordsListItem = (props) => {

    const [columnCount, setColumnCount] = useState(3);
    
    const closeInfo = () => {

    }

    const setShowInfo = () => {
        props.modalShowToggle('chartInfo', true, closeInfo, props.getValue(props.headerTitle), props.headerTitle);
    }

    const keywords = (props.keywordsList && props.keywordsList.length) &&
                    props.keywordsList.map((k,i)=>{
                        
                        return (
                                <tr key={i}>
                                    <td>{i+1}</td>
                                    <td style={{width: 'auto', maxWidth: '400px'}}>
                                        <span className={s.keyword} style={{background: k.color ? k.color : '', color: k.textColor ? k.textColor : ''}}>
                                            {k.name}
                                        </span>
                                    </td>
                                    <td>{k.count}</td>
                                    {
                                        k.agression !== undefined && <td>{
                                                            <div  className={s.KeywordsListPivots}>
                                                                {k.agression ?   <AgressiveIcon /> : null}
                                                                {k.advertising ? <AdvertisingIcon /> : null}
                                                                {k.swearing ? <SwearingIcon /> : null}
                                                            </div>
                                                        }</td>
                                    }
                                    <td>
                                        <div className={s.KeywordsListPivots}>
                                            {k.neutral ?   <div className={s.KeywordsListPivotsItem+' '+s.NEUTRAL}>
                                                                {k.neutral} 
                                                            </div>
                                            : null}
                                            {k.negative ?   <div className={s.KeywordsListPivotsItem+' '+s.NEGATIVE}>
                                                                {k.negative} 
                                                            </div>
                                            : null}
                                            {k.positive ?   <div className={s.KeywordsListPivotsItem+' '+s.POSITIVE}>
                                                                {k.positive} 
                                                            </div>
                                            : null}
                                            {k.undefined ?   <div className={s.KeywordsListPivotsItem+' '+s.UNDEFINED}>
                                                                {k.undefined} 
                                                            </div>
                                            : null}
                                        </div>
                                        
                                    </td>
                                </tr>
                        )
                    })

    return (
        <div className={s.KeywordsList}>
            <div className={s.KeywordsListHeader}>
                <span className={s.KeywordsTitle}>{props.title}</span>
                <div className={s.KeywordsListButtons}>
                {props.getValue(props.headerTitle+'_CHART_INFO') !== props.headerTitle+'_CHART_INFO' ? <StandartButton background={'white'} icon={InfoIcon} callback={ setShowInfo.bind(this, props.headerTitle) }/> : null}
                </div>
            </div>
            <div className={s.KeywordsListBody}>
                <div className={s.KeywordsListTable}>
                    <div className={s.tableHeader}>
                        <table>
                            <thead>
                                <tr>

                                    <th></th>
                                    <th>{props.title}</th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {keywords ? keywords : null}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </div>
    )
}
const KeywordsList = connect(mapStateToProps, {modalShowToggle})(KeywordsListItem                      )

export default KeywordsList;